import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ImageComponent } from '../../../osp-ui/components/media/image/image.component';
import { ThumbnailSize } from '../../enums/thumbnail-size.enum';
import { ImageKeyFormatPipe } from '../../pipes/image-key-format.pipe';

@Component({
  selector: 'osp-thumbnail',
  standalone: true,
  imports: [ImageComponent, ImageKeyFormatPipe],
  templateUrl: './thumbnail.component.html',
  styleUrl: './thumbnail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThumbnailComponent {
  key = input<string | null | undefined>(null);
  size = input(ThumbnailSize.S);
  altText = input('');
  directImage = input(false);
  customerId = input<string | undefined>(undefined);
}
